import type { ProjectProps } from "@/types/project/project.type";
import type { Locale } from "@/locales";

/**
 * Pick the locale-appropriate text fields off a project document. Bangla
 * fields are optional on the doc — if absent (or empty), fall back to
 * the canonical English fields so old documents keep rendering unchanged.
 *
 * Usage in components:
 *
 *   const { title, shortDescription, description } =
 *     pickProjectLocale(project, locale);
 */
export const pickProjectLocale = (
  p: ProjectProps,
  locale: Locale
): {
  title: string;
  shortDescription: string;
  description: string;
} => ({
  title: locale === "bn" && p.titleBn ? p.titleBn : p.title,
  shortDescription:
    locale === "bn" && p.shortDescriptionBn
      ? p.shortDescriptionBn
      : p.shortDescription,
  description:
    locale === "bn" && p.descriptionBn ? p.descriptionBn : p.description,
});
